// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.program-process-page {
  width: 100%;
  max-width: 1440px;
  min-width: 0;
  margin: 0 auto;
  padding: 1.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.82rem;
}

.breadcrumb-link,
.breadcrumb-current {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.breadcrumb-link {
  color: var(--ca-primary, #0e2e80);
  font-weight: 600;
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 700;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0 0 1.65rem;
}

.page-heading {
  min-width: 0;
}

.page-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.55rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.eyebrow-mark {
  width: 0.45rem;
  height: 0.45rem;
  flex: 0 0 0.45rem;
  border-radius: 2px;
  background: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);
}

.page-heading h1 {
  margin: 0 0 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.45rem, 2.1vw, 1.85rem);
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.25;
}

.page-heading > p:last-child {
  max-width: 760px;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.page-header-meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
  max-width: min(34%, 24rem);
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.header-meta-icon {
  display: grid;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 2.4rem;
  place-items: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.1rem;
}

.page-header-meta > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.1rem;
}

.page-header-meta strong {
  overflow: hidden;
  color: var(--ca-text-primary, #172033);
  font-size: 0.78rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page-header-meta > div > span {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
}

.process-stepper {
  display: flex;
  align-items: stretch;
  gap: 0.7rem;
  margin-bottom: 1.15rem;
  padding: 0.75rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.step-item {
  display: flex;
  min-width: 0;
  flex: 1 1 0;
  align-items: center;
  gap: 0.7rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-md, 8px);
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
  text-align: left;
  cursor: default;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.step-item.active {
  border-color: #d8e3ff;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.step-item.completed {
  color: var(--ca-success, #198754);
}

.step-number {
  display: grid;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 0.7rem;
  background: var(--ca-surface, #fff);
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.95rem;
}

.step-item.active .step-number {
  border-color: transparent;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.step-item.completed .step-number {
  border-color: var(--ca-success-border, #b7e3ca);
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.step-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.12rem;
}

.step-copy strong {
  color: inherit;
  font-size: 0.82rem;
  font-weight: 750;
  line-height: 1.35;
}

.step-copy small {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.68rem;
  line-height: 1.4;
}

.step-connector {
  align-self: center;
  width: 1.2rem;
  height: 2px;
  flex: 0 0 1.2rem;
  background: var(--ca-border, #dfe4ec);
}

.step-connector.completed {
  background: var(--ca-success, #198754);
}

.process-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.process-card-header {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.2rem 1.35rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(110deg, #fff 0%, #fbfcff 100%);
}

.step-heading-icon {
  display: grid;
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  place-items: center;
  border: 1px solid #d8e3ff;
  border-radius: 0.8rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.15rem;
}

.step-heading-copy {
  min-width: 0;
  flex: 1 1 auto;
}

.section-eyebrow {
  display: block;
  margin-bottom: 0.25rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.step-heading-copy h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.12rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.step-heading-copy p {
  margin: 0.35rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.81rem;
  line-height: 1.5;
}

.operation-tag {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid #d8e3ff;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.72rem;
  font-weight: 750;
}

.operation-tag--update {
  border-color: var(--ca-info-border, #b7dced);
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.form-step {
  padding: 1.35rem;
}

.form-section-intro {
  margin-bottom: 1.15rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.form-section-intro h3 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
  font-weight: 750;
}

.form-section-intro p {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
  line-height: 1.55;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.1rem 1.25rem;
}

.form-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
}

.form-field--wide {
  grid-column: 1/-1;
}

.form-field > label {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.79rem;
  font-weight: 700;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
  font-weight: 800;
}

.optional-label {
  margin-left: 0.35rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.7rem;
  font-weight: 500;
}

.form-control,
.form-select {
  width: 100%;
  min-width: 0;
  min-height: 2.55rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.86rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}

textarea.form-control {
  min-height: 6rem;
  resize: vertical;
}

.multi-select {
  min-height: 9rem;
  padding: 0.35rem;
}

.multi-select option {
  padding: 0.42rem 0.55rem;
  border-radius: 4px;
}

.standards-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
  padding: 0.85rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
}

.standard-option {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  min-width: 0;
  padding: 0.55rem 0.6rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-sm, 6px);
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  line-height: 1.45;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.standard-option:hover {
  border-color: var(--ca-primary-light, #2850ad);
  background: var(--ca-surface-hover, #f8faff);
}
.standard-option .form-check-input {
  flex: 0 0 auto;
  margin-top: 0.15rem;
  cursor: pointer;
}
.standard-option span {
  min-width: 0;
}

.field-hint {
  align-self: flex-end;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.7rem;
  line-height: 1.4;
}

.field-error {
  color: var(--ca-danger, #dc3545);
  font-size: 0.72rem;
  line-height: 1.4;
}

.picker-control {
  display: flex;
  min-width: 0;
}

.picker-control .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background: var(--ca-surface-hover, #f8faff);
  cursor: pointer;
}

.picker-button {
  display: grid;
  width: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-left: 0;
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.picker-button:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.picker-button:focus-visible,
.icon-close-button:focus-visible,
.user-option:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.readonly-value {
  display: flex;
  min-height: 2.55rem;
  align-items: center;
  gap: 0.55rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-bg, #f5f7fb);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
}

.status-dot {
  width: 0.48rem;
  height: 0.48rem;
  flex: 0 0 0.48rem;
  border-radius: 50%;
  background: var(--ca-success, #198754);
}

.status-dot--failed {
  background: var(--ca-danger, #dc3545);
}

.inline-error,
.success-banner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin: 1rem 1.35rem 0;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.inline-error > span,
.inline-warning > span {
  flex: 1 1 auto;
}

.inline-warning {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin: 1rem 1.35rem 0;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-warning-border, #f3d79b);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-warning-bg, #fff7e6);
  color: #7a5700;
  font-size: 0.82rem;
}

.success-banner {
  border-color: var(--ca-success-border, #b7e3ca);
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.success-banner > span {
  flex: 1 1 auto;
  font-weight: 650;
}

.step-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.35rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: #fcfdff;
}

.footer-actions,
.state-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.required-note {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.72rem;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.55rem;
  padding: 0.6rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.button-spinner {
  display: inline-block;
  width: 0.9rem;
  height: 0.9rem;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: dpp-spin 0.8s linear infinite;
}

.state-panel {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.state-panel > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 2rem;
}

.state-panel h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 750;
}

.state-panel p {
  max-width: 40rem;
  margin: 0 0 0.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
  line-height: 1.6;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: dpp-spin 0.8s linear infinite;
}

.user-picker-backdrop {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(4, 27, 56, 0.56);
  backdrop-filter: blur(2px);
}

.user-picker-dialog {
  display: flex;
  width: min(100%, 620px);
  max-height: min(82vh, 760px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 16px;
  background: var(--ca-surface, #fff);
  box-shadow: 0 22px 65px rgba(7, 17, 46, 0.25);
}

.user-picker-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.15rem 1.25rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.user-picker-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.75rem;
}

.user-picker-icon {
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 2.5rem;
  place-items: center;
  border-radius: 0.75rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.15rem;
}

.user-picker-heading h2 {
  margin: 0 0 0.2rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 750;
}

.user-picker-heading p {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.77rem;
  line-height: 1.45;
}

.icon-close-button {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  place-items: center;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--ca-text-tertiary, #6f7b91);
  cursor: pointer;
}

.icon-close-button:hover {
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-primary, #172033);
}

.user-picker-search {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 1rem 1.25rem 0.75rem;
  padding-left: 0.75rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  color: var(--ca-text-muted, #8c96a8);
}

.user-picker-search .form-control {
  border: 0;
  box-shadow: none;
}

.user-list {
  min-height: 0;
  overflow-y: auto;
  padding: 0 0.75rem 0.5rem;
}

.user-option {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.55rem;
  border: 0;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fff;
  color: var(--ca-text-primary, #172033);
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.user-option:hover {
  background: var(--ca-surface-hover, #f8faff);
}

.user-avatar {
  display: grid;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 2.4rem;
  place-items: center;
  border-radius: 50%;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.85rem;
  font-weight: 800;
}

.user-option-main {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.12rem;
}

.user-option-main strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 750;
}

.user-option-main > span {
  overflow: hidden;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.75rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-option-main small {
  overflow: hidden;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.7rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-option-chevron {
  color: var(--ca-text-muted, #8c96a8);
}

.user-picker-state,
.user-picker-empty,
.user-picker-error {
  display: flex;
  min-height: 8rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.65rem;
  padding: 1.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  text-align: center;
}

.user-picker-empty {
  flex-direction: column;
  color: var(--ca-text-tertiary, #6f7b91);
}

.user-picker-empty i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.75rem;
}

.user-picker-empty p {
  margin: 0;
}

.user-picker-error {
  color: var(--ca-danger, #dc3545);
}

.user-picker-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 1.25rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: #fcfdff;
}

.user-picker-footer > span {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
}

@keyframes dpp-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .page-header-meta {
    max-width: 38%;
  }
  .step-copy small {
    display: none;
  }
  .step-connector {
    width: 0.5rem;
    flex-basis: 0.5rem;
  }
}
@media (max-width: 767.98px) {
  .program-process-page {
    padding: 1rem 0.75rem 1.5rem;
  }
  .page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
  }
  .page-header-meta {
    max-width: 100%;
    width: 100%;
  }
  .process-stepper {
    flex-direction: column;
    gap: 0.35rem;
    padding: 0.55rem;
  }
  .step-item {
    flex: 0 0 auto;
  }
  .step-copy small {
    display: block;
  }
  .step-connector {
    width: 2px;
    height: 0.55rem;
    flex: 0 0 0.55rem;
    align-self: flex-start;
    margin-left: 1.65rem;
  }
  .process-card-header {
    align-items: flex-start;
    padding: 1rem;
  }
  .operation-tag {
    font-size: 0.68rem;
  }
  .form-step {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
  }
  .standards-options {
    grid-template-columns: minmax(0, 1fr);
  }
  .form-field--wide {
    grid-column: auto;
  }
  .step-footer {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 0.9rem 1rem;
  }
  .step-footer > .btn,
  .footer-actions .btn {
    width: 100%;
  }
  .footer-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .required-note {
    align-self: flex-end;
  }
  .inline-error,
  .inline-warning,
  .success-banner {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .success-banner .btn {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .process-card-header {
    flex-wrap: wrap;
  }
  .step-heading-copy {
    flex-basis: calc(100% - 3.6rem);
  }
  .operation-tag {
    margin-left: 3.55rem;
  }
  .user-picker-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .user-picker-dialog {
    width: 100%;
    max-height: 88vh;
    border-radius: 16px 16px 0 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/data-protection-program/data-protection-program-process/data-protection-program-process.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,iDAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;AAFF;;AAKA;;EAEE,oBAAA;EACA,mBAAA;EACA,YAAA;AAFF;;AAKA;EACE,iCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,4CAAA;EACA,uDAAA;AAFF;;AAKA;EACE,mBAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,sBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,uCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,6BAAA;EACA,uCAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,gEAAA;AAFF;;AAKA;EACE,qBAAA;EACA,6CAAA;EACA,iCAAA;AAFF;;AAKA;EACE,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,qBAAA;EACA,mCAAA;EACA,uCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,sCAAA;EACA,WAAA;AAFF;;AAKA;EACE,+CAAA;EACA,yCAAA;EACA,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;AAFF;;AAKA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,uCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,qCAAA;AAFF;;AAKA;EACE,sCAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,wDAAA;EACA,0DAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,4CAAA;EACA,sCAAA;EACA,8BAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,sBAAA;EACA,wDAAA;AAFF;;AAKA;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,kBAAA;EACA,0DAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;;EAEE,4CAAA;EACA,gDAAA;EACA,UAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,wBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iDAAA;EACA,uCAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gEAAA;AAFF;AAIE;EACE,8CAAA;EACA,4CAAA;AAFJ;AAKE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AAHJ;AAME;EACE,YAAA;AAJJ;;AAQA;EACE,oBAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;AALF;;AAQA;EACE,0BAAA;EACA,6BAAA;EACA,4CAAA;EACA,eAAA;AALF;;AAQA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,cAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AALF;;AAQA;EACE,2CAAA;AALF;;AAQA;;;EAGE,0CAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,iDAAA;EACA,uCAAA;EACA,iCAAA;EACA,wCAAA;EACA,kBAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AALF;;AAQA;EACE,qCAAA;AALF;;AAQA;;EAEE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;AALF;;AAQA;;EAEE,cAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,mDAAA;EACA,uCAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,+CAAA;EACA,yCAAA;EACA,iCAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,qDAAA;EACA,mBAAA;AALF;;AAQA;;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AALF;;AAQA;EACE,uCAAA;EACA,kBAAA;AALF;;AAQA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uFAAA;AALF;;AAQA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AALF;;AAQA;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AALF;;AAQA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AALF;;AAQA;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AALF;;AAQA;;EAEE,mBAAA;EACA,aAAA;AALF;;AAQA;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,2CAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;AALF;;AAQA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,uCAAA;EACA,kBAAA;EACA,gEAAA;AALF;;AAQA;EACE,uCAAA;EACA,eAAA;AALF;;AAQA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,wCAAA;AALF;;AAQA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,mCAAA;EACA,6CAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,wBAAA;EACA,wDAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,uCAAA;EACA,eAAA;AALF;;AAQA;EACE,2CAAA;EACA,sCAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,qBAAA;EACA,iDAAA;EACA,uCAAA;EACA,oCAAA;AALF;;AAQA;EACE,SAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;AALF;;AAQA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,SAAA;EACA,wDAAA;EACA,gBAAA;EACA,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AALF;;AAQA;EACE,4CAAA;AALF;;AAQA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AALF;;AAQA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,oCAAA;AALF;;AAQA;;;EAGE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;AALF;;AAQA;EACE,sBAAA;EACA,uCAAA;AALF;;AAQA;EACE,uCAAA;EACA,kBAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,qDAAA;EACA,mBAAA;AALF;;AAQA;EACE,uCAAA;EACA,kBAAA;AALF;;AAQA;EACE;IAAK,yBAAA;EAJL;AACF;AAMA;EACE;IACE,cAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,aAAA;IACA,kBAAA;EANF;AACF;AASA;EACE;IACE,4BAAA;EAPF;EAUA;IACE,uBAAA;IACA,sBAAA;IACA,SAAA;EARF;EAWA;IACE,eAAA;IACA,WAAA;EATF;EAYA;IACE,sBAAA;IACA,YAAA;IACA,gBAAA;EAVF;EAaA;IACE,cAAA;EAXF;EAcA;IACE,cAAA;EAZF;EAeA;IACE,UAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,oBAAA;EAbF;EAgBA;IACE,uBAAA;IACA,aAAA;EAdF;EAiBA;IACE,kBAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,qCAAA;IACA,SAAA;EAjBF;EAoBA;IACE,qCAAA;EAlBF;EAqBA;IACE,iBAAA;EAnBF;EAsBA;IACE,oBAAA;IACA,8BAAA;IACA,oBAAA;EApBF;EAuBA;;IAEE,WAAA;EArBF;EAwBA;IACE,oBAAA;IACA,sBAAA;EAtBF;EAyBA;IACE,oBAAA;EAvBF;EA0BA;;;IAGE,kBAAA;IACA,iBAAA;EAxBF;EA2BA;IACE,WAAA;EAzBF;AACF;AA4BA;EACE;IACE,eAAA;EA1BF;EA6BA;IACE,+BAAA;EA3BF;EA8BA;IACE,oBAAA;EA5BF;EA+BA;IACE,qBAAA;IACA,UAAA;EA7BF;EAgCA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;EA9BF;AACF;AAiCA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EA/BF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.program-process-page {\n  width: 100%;\n  max-width: 1440px;\n  min-width: 0;\n  margin: 0 auto;\n  padding: 1.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.82rem;\n}\n\n.breadcrumb-link,\n.breadcrumb-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.breadcrumb-link {\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 600;\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 700;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin: 0 0 1.65rem;\n}\n\n.page-heading {\n  min-width: 0;\n}\n\n.page-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.55rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.eyebrow-mark {\n  width: 0.45rem;\n  height: 0.45rem;\n  flex: 0 0 0.45rem;\n  border-radius: 2px;\n  background: var(--ca-primary-light, #2850ad);\n  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);\n}\n\n.page-heading h1 {\n  margin: 0 0 0.45rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.45rem, 2.1vw, 1.85rem);\n  font-weight: 750;\n  letter-spacing: -0.035em;\n  line-height: 1.25;\n}\n\n.page-heading > p:last-child {\n  max-width: 760px;\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.page-header-meta {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.75rem;\n  max-width: min(34%, 24rem);\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.header-meta-icon {\n  display: grid;\n  width: 2.4rem;\n  height: 2.4rem;\n  flex: 0 0 2.4rem;\n  place-items: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.1rem;\n}\n\n.page-header-meta > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.page-header-meta strong {\n  overflow: hidden;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.78rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.page-header-meta > div > span {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.7rem;\n}\n\n.process-stepper {\n  display: flex;\n  align-items: stretch;\n  gap: 0.7rem;\n  margin-bottom: 1.15rem;\n  padding: 0.75rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.step-item {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 0;\n  align-items: center;\n  gap: 0.7rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid transparent;\n  border-radius: var(--ca-radius-md, 8px);\n  background: transparent;\n  color: var(--ca-text-secondary, #4b5870);\n  text-align: left;\n  cursor: default;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.step-item.active {\n  border-color: #d8e3ff;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.step-item.completed {\n  color: var(--ca-success, #198754);\n}\n\n.step-number {\n  display: grid;\n  width: 2.25rem;\n  height: 2.25rem;\n  flex: 0 0 2.25rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 0.7rem;\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.95rem;\n}\n\n.step-item.active .step-number {\n  border-color: transparent;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.step-item.completed .step-number {\n  border-color: var(--ca-success-border, #b7e3ca);\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n}\n\n.step-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.12rem;\n}\n\n.step-copy strong {\n  color: inherit;\n  font-size: 0.82rem;\n  font-weight: 750;\n  line-height: 1.35;\n}\n\n.step-copy small {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.68rem;\n  line-height: 1.4;\n}\n\n.step-connector {\n  align-self: center;\n  width: 1.2rem;\n  height: 2px;\n  flex: 0 0 1.2rem;\n  background: var(--ca-border, #dfe4ec);\n}\n\n.step-connector.completed {\n  background: var(--ca-success, #198754);\n}\n\n.process-card {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.process-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.2rem 1.35rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(110deg, #fff 0%, #fbfcff 100%);\n}\n\n.step-heading-icon {\n  display: grid;\n  width: 2.7rem;\n  height: 2.7rem;\n  flex: 0 0 2.7rem;\n  place-items: center;\n  border: 1px solid #d8e3ff;\n  border-radius: 0.8rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.15rem;\n}\n\n.step-heading-copy {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.section-eyebrow {\n  display: block;\n  margin-bottom: 0.25rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n}\n\n.step-heading-copy h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.12rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.step-heading-copy p {\n  margin: 0.35rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.81rem;\n  line-height: 1.5;\n}\n\n.operation-tag {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid #d8e3ff;\n  border-radius: 999px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.72rem;\n  font-weight: 750;\n}\n\n.operation-tag--update {\n  border-color: var(--ca-info-border, #b7dced);\n  background: var(--ca-info-bg, #eaf6fc);\n  color: var(--ca-info, #1d7fbf);\n}\n\n.form-step {\n  padding: 1.35rem;\n}\n\n.form-section-intro {\n  margin-bottom: 1.15rem;\n  padding-bottom: 0.8rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.form-section-intro h3 {\n  margin: 0 0 0.3rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.95rem;\n  font-weight: 750;\n}\n\n.form-section-intro p {\n  margin: 0;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.78rem;\n  line-height: 1.55;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.1rem 1.25rem;\n}\n\n.form-field {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.form-field--wide {\n  grid-column: 1 / -1;\n}\n\n.form-field > label {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.79rem;\n  font-weight: 700;\n}\n\n.required-mark {\n  color: var(--ca-danger, #dc3545);\n  font-weight: 800;\n}\n\n.optional-label {\n  margin-left: 0.35rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.form-control,\n.form-select {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.55rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.86rem;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.form-control::placeholder {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n  outline: 0;\n}\n\ntextarea.form-control {\n  min-height: 6rem;\n  resize: vertical;\n}\n\n.multi-select {\n  min-height: 9rem;\n  padding: 0.35rem;\n}\n\n.multi-select option {\n  padding: 0.42rem 0.55rem;\n  border-radius: 4px;\n}\n\n.standards-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.55rem;\n  padding: 0.85rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n}\n\n.standard-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  min-width: 0;\n  padding: 0.55rem 0.6rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-sm, 6px);\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.78rem;\n  line-height: 1.45;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  &:hover {\n    border-color: var(--ca-primary-light, #2850ad);\n    background: var(--ca-surface-hover, #f8faff);\n  }\n\n  .form-check-input {\n    flex: 0 0 auto;\n    margin-top: 0.15rem;\n    cursor: pointer;\n  }\n\n  span {\n    min-width: 0;\n  }\n}\n\n.field-hint {\n  align-self: flex-end;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.7rem;\n  line-height: 1.4;\n}\n\n.field-error {\n  color: var(--ca-danger, #dc3545);\n  font-size: 0.72rem;\n  line-height: 1.4;\n}\n\n.picker-control {\n  display: flex;\n  min-width: 0;\n}\n\n.picker-control .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  background: var(--ca-surface-hover, #f8faff);\n  cursor: pointer;\n}\n\n.picker-button {\n  display: grid;\n  width: 2.75rem;\n  flex: 0 0 2.75rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-left: 0;\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.picker-button:hover {\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.picker-button:focus-visible,\n.icon-close-button:focus-visible,\n.user-option:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 2px;\n}\n\n.readonly-value {\n  display: flex;\n  min-height: 2.55rem;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-bg, #f5f7fb);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.85rem;\n}\n\n.status-dot {\n  width: 0.48rem;\n  height: 0.48rem;\n  flex: 0 0 0.48rem;\n  border-radius: 50%;\n  background: var(--ca-success, #198754);\n}\n\n.status-dot--failed {\n  background: var(--ca-danger, #dc3545);\n}\n\n.inline-error,\n.success-banner {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.7rem;\n  margin: 1rem 1.35rem 0;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n}\n\n.inline-error > span,\n.inline-warning > span {\n  flex: 1 1 auto;\n}\n\n.inline-warning {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.7rem;\n  margin: 1rem 1.35rem 0;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--ca-warning-border, #f3d79b);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-warning-bg, #fff7e6);\n  color: #7a5700;\n  font-size: 0.82rem;\n}\n\n.success-banner {\n  border-color: var(--ca-success-border, #b7e3ca);\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n}\n\n.success-banner > span {\n  flex: 1 1 auto;\n  font-weight: 650;\n}\n\n.step-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.35rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fcfdff;\n}\n\n.footer-actions,\n.state-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.required-note {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.72rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  min-height: 2.55rem;\n  padding: 0.6rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n  color: #fff;\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-hover, #f8faff);\n  color: var(--ca-primary-dark, #0d2863);\n}\n\n.btn-primary:disabled,\n.btn-secondary:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.button-spinner {\n  display: inline-block;\n  width: 0.9rem;\n  height: 0.9rem;\n  border: 2px solid rgba(255, 255, 255, 0.45);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: dpp-spin 0.8s linear infinite;\n}\n\n.state-panel {\n  display: flex;\n  min-height: 15rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.state-panel > i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 2rem;\n}\n\n.state-panel h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.15rem;\n  font-weight: 750;\n}\n\n.state-panel p {\n  max-width: 40rem;\n  margin: 0 0 0.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.88rem;\n  line-height: 1.6;\n}\n\n.error-state > i {\n  color: var(--ca-danger, #dc3545);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: dpp-spin 0.8s linear infinite;\n}\n\n.user-picker-backdrop {\n  position: fixed;\n  z-index: 2000;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(4, 27, 56, 0.56);\n  backdrop-filter: blur(2px);\n}\n\n.user-picker-dialog {\n  display: flex;\n  width: min(100%, 620px);\n  max-height: min(82vh, 760px);\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 16px;\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 22px 65px rgba(7, 17, 46, 0.25);\n}\n\n.user-picker-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.15rem 1.25rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.user-picker-heading {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.user-picker-icon {\n  display: grid;\n  width: 2.5rem;\n  height: 2.5rem;\n  flex: 0 0 2.5rem;\n  place-items: center;\n  border-radius: 0.75rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.15rem;\n}\n\n.user-picker-heading h2 {\n  margin: 0 0 0.2rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1rem;\n  font-weight: 750;\n}\n\n.user-picker-heading p {\n  margin: 0;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.77rem;\n  line-height: 1.45;\n}\n\n.icon-close-button {\n  display: grid;\n  width: 2rem;\n  height: 2rem;\n  flex: 0 0 2rem;\n  place-items: center;\n  border: 0;\n  border-radius: 0.5rem;\n  background: transparent;\n  color: var(--ca-text-tertiary, #6f7b91);\n  cursor: pointer;\n}\n\n.icon-close-button:hover {\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-primary, #172033);\n}\n\n.user-picker-search {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  margin: 1rem 1.25rem 0.75rem;\n  padding-left: 0.75rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.user-picker-search .form-control {\n  border: 0;\n  box-shadow: none;\n}\n\n.user-list {\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 0.75rem 0.5rem;\n}\n\n.user-option {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 0.55rem;\n  border: 0;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fff;\n  color: var(--ca-text-primary, #172033);\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.user-option:hover {\n  background: var(--ca-surface-hover, #f8faff);\n}\n\n.user-avatar {\n  display: grid;\n  width: 2.4rem;\n  height: 2.4rem;\n  flex: 0 0 2.4rem;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.85rem;\n  font-weight: 800;\n}\n\n.user-option-main {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 0.12rem;\n}\n\n.user-option-main strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n  font-weight: 750;\n}\n\n.user-option-main > span {\n  overflow: hidden;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.75rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-option-main small {\n  overflow: hidden;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.7rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-option-chevron {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.user-picker-state,\n.user-picker-empty,\n.user-picker-error {\n  display: flex;\n  min-height: 8rem;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  padding: 1.25rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n  text-align: center;\n}\n\n.user-picker-empty {\n  flex-direction: column;\n  color: var(--ca-text-tertiary, #6f7b91);\n}\n\n.user-picker-empty i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 1.75rem;\n}\n\n.user-picker-empty p {\n  margin: 0;\n}\n\n.user-picker-error {\n  color: var(--ca-danger, #dc3545);\n}\n\n.user-picker-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.8rem 1.25rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fcfdff;\n}\n\n.user-picker-footer > span {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.75rem;\n}\n\n@keyframes dpp-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 900px) {\n  .page-header-meta {\n    max-width: 38%;\n  }\n\n  .step-copy small {\n    display: none;\n  }\n\n  .step-connector {\n    width: 0.5rem;\n    flex-basis: 0.5rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .program-process-page {\n    padding: 1rem 0.75rem 1.5rem;\n  }\n\n  .page-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .page-header-meta {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .process-stepper {\n    flex-direction: column;\n    gap: 0.35rem;\n    padding: 0.55rem;\n  }\n\n  .step-item {\n    flex: 0 0 auto;\n  }\n\n  .step-copy small {\n    display: block;\n  }\n\n  .step-connector {\n    width: 2px;\n    height: 0.55rem;\n    flex: 0 0 0.55rem;\n    align-self: flex-start;\n    margin-left: 1.65rem;\n  }\n\n  .process-card-header {\n    align-items: flex-start;\n    padding: 1rem;\n  }\n\n  .operation-tag {\n    font-size: 0.68rem;\n  }\n\n  .form-step {\n    padding: 1rem;\n  }\n\n  .form-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 1rem;\n  }\n\n  .standards-options {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .form-field--wide {\n    grid-column: auto;\n  }\n\n  .step-footer {\n    align-items: stretch;\n    flex-direction: column-reverse;\n    padding: 0.9rem 1rem;\n  }\n\n  .step-footer > .btn,\n  .footer-actions .btn {\n    width: 100%;\n  }\n\n  .footer-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .required-note {\n    align-self: flex-end;\n  }\n\n  .inline-error,\n  .inline-warning,\n  .success-banner {\n    margin-right: 1rem;\n    margin-left: 1rem;\n  }\n\n  .success-banner .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .process-card-header {\n    flex-wrap: wrap;\n  }\n\n  .step-heading-copy {\n    flex-basis: calc(100% - 3.6rem);\n  }\n\n  .operation-tag {\n    margin-left: 3.55rem;\n  }\n\n  .user-picker-backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .user-picker-dialog {\n    width: 100%;\n    max-height: 88vh;\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
